import AssetWrapper from 'atoms/Asset/AssetWrapper';
import React from 'react';
import { MarkupElement } from 'src/api/models/MarkupHtml';

export interface ImageHtmlComponents {
  type: 'tag';
  tagName: 'img';
  properties: {
    src: string;
    alt: string;
  };
}

export const structuredImageHtmlComponents = (htmlAst: MarkupElement): ImageHtmlComponents => {
  // Images are always single children of a p tag
  if (htmlAst.tagName !== 'p') return null;

  const imageChild: MarkupElement = (htmlAst.children as MarkupElement[])
    .filter((c) => c.type === 'element')
    .find((c) => c.tagName === 'img');
  if (!imageChild) return null;

  return {
    type: 'tag',
    tagName: 'img',
    properties: { src: imageChild.properties.src, alt: imageChild.properties.alt },
  };
};

interface ImageHtmlComponentProps {
  structuredHtml: ImageHtmlComponents;
  key: string;
}

const ImageHtmlComponent = ({ structuredHtml, key }: ImageHtmlComponentProps): JSX.Element => {
  return (
    <AssetWrapper
      key={key}
      className='ast-image-element'
      cover={true}
      imageProps={{
        src: structuredHtml.properties.src,
        alt: structuredHtml.properties.alt,
      }}
    />
  );
};

export default ImageHtmlComponent;
